import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { doubleParagraphRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type DoubleParagraphProps = HTMLAttributes<HTMLElement> &
  Partial<{
    overline: string
    paragraph_1_paragraph: string
    paragraph_2_paragraph: string
  }>

const DoubleParagraph = ({
  overline,
  paragraph_1_paragraph: paragraph_1,
  paragraph_2_paragraph: paragraph_2,
  ...props
}: DoubleParagraphProps) => {
  return (
    <Motion animation={doubleParagraphRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-[1.6rem] md:gap-y-[3.2rem]">
              {overline ? (
                <div className="col-span-4 md:col-span-5 md:col-start-2 lg:col-span-11 lg:col-start-2">
                  <Typography
                    variant="label"
                    paragraph
                    className="font-gillsans uppercase text-copper"
                    data-motion-overline
                  >
                    {overline}
                  </Typography>
                </div>
              ) : null}

              {paragraph_1 || paragraph_2 ? (
                <div
                  className={cn(
                    'col-span-4 md:col-span-6 lg:col-span-12',
                    'grid grid-cols-2 gap-x-margin gap-y-gutter'
                  )}
                >
                  {paragraph_1 ? (
                    <div className="col-span-2 md:col-span-1">
                      <Typography
                        variant="h6"
                        paragraph
                        className="font-timesnow"
                        data-motion-paragraph-1
                      >
                        {paragraph_1}
                      </Typography>
                    </div>
                  ) : null}

                  {paragraph_2 ? (
                    <div className="col-span-2 md:col-span-1">
                      <Typography
                        variant="body"
                        paragraph
                        className="font-gillsans font-light"
                        data-motion-paragraph-2
                      >
                        {paragraph_2}
                      </Typography>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Grid>
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default DoubleParagraph
